import React from "react"
import FormInputLabel from "../labels/form-field-label"
import useFormField from "../../../../hooks/useFormField"
import FormFieldError from "../labels/form-field-error"
import ToggleInfo from "../buttons/toggle-info-button"

export default function RadioGroupInput({
  name,
  id,
  options = [],
  label,
  description,
  required,
  validateField,
  displayOption,
  globalValue,
  setGlobalValue,
  error,
  setError,
  closeModalLabel,
  moreInfoLabel,
}) {
  const preValue = options.find((option) => option.checked)?.value
  const { value, handleSelectionChange } = useFormField(preValue, validateField, globalValue, setGlobalValue, setError)

  return (
    <div
      className={`form-element form-element--choice__single is-filled Form__Element  ${displayOption} ${required ? "is-required" : ""} ${error ? "is-invalid" : ""}`}
      data-f-element-name={name}
      data-f-type="choice"
      aria-label={description}
    >
      <div className="form-labels">
        <FormInputLabel id={id} label={label} required={required} />
        <ToggleInfo description={description} id={id} closeModalLabel={closeModalLabel} moreInfoLabel={moreInfoLabel} />
      </div>
      <div className="choice-wrapper" id={id}>
        {options &&
          options.map((option, index) => (
            <div key={index} className="form-input choice-item">
              <label className="form-label">
                <input
                  type="radio"
                  name={name}
                  value={option.value}
                  checked={value === option.value}
                  onChange={(e) => handleSelectionChange(e.target.value)}
                  className="form-input--radio"
                  data-f-datainput=""
                  aria-required={required}
                  title={description}
                  required={required}
                />
                <span className="form-label__text">{option.label}</span>
              </label>
            </div>
          ))}
      </div>
      <FormFieldError name={name} error={error} />
    </div>
  )
}
